<script>
    import Name from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Name.svelte?1733898724591';
    import Brand from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/Brand.svelte?1733898724591';

    export let product;
    export let brand;
</script>

<div class="m-product-detail__header">
    <div class="product-name">
        <Name {product} {brand} />
        <Brand {brand} />
    </div>
</div>
